import React, { forwardRef } from 'react';
import { cn } from '../../utils/cn';

const SIZES = {
  sm: { track: 'w-7 h-4',  thumb: 'w-3 h-3', checked: 'peer-checked:translate-x-3' },
  md: { track: 'w-9 h-5',  thumb: 'w-4 h-4', checked: 'peer-checked:translate-x-4' },
  lg: { track: 'w-11 h-6', thumb: 'w-5 h-5', checked: 'peer-checked:translate-x-5' },
};

export const Switch = forwardRef(function Switch(
  { size = 'md', label, description, isDisabled, isInvalid, className, ...rest },
  ref
) {
  const s = SIZES[size];
  return (
    <label className={cn('inline-flex items-center gap-2.5 cursor-pointer select-none', isDisabled && 'opacity-50 cursor-not-allowed', className)}>
      <span className={cn('relative inline-flex shrink-0 items-center', s.track)}>
        <input
          ref={ref}
          type="checkbox"
          role="switch"
          disabled={isDisabled}
          aria-invalid={isInvalid || undefined}
          className="peer absolute inset-0 opacity-0 cursor-inherit"
          {...rest}
        />
        <span className={cn(
          'absolute inset-0 rounded-full transition-colors duration-fast pointer-events-none',
          'bg-cream-3 border border-border-strong',
          'peer-checked:bg-ink peer-checked:border-ink',
          'peer-focus-visible:ring-2 peer-focus-visible:ring-ink/30 peer-focus-visible:ring-offset-1 peer-focus-visible:ring-offset-bg',
          isInvalid && 'border-danger',
        )} />
        <span className={cn(
          'absolute left-0.5 top-1/2 -translate-y-1/2 rounded-full bg-cream shadow-xs',
          'transition-transform duration-fast pointer-events-none',
          s.thumb,
          s.checked,
        )} />
      </span>
      {(label || description) && (
        <span className="min-w-0 leading-tight">
          {label && <span className="block text-sm text-text">{label}</span>}
          {description && <span className="block text-xs text-mute mt-0.5">{description}</span>}
        </span>
      )}
    </label>
  );
});

export default Switch;
